import QuestCreateUpdate from "./QuestCreateUpdate.jsx";

export default {
  QuestCreateUpdate,
}
